import useVoucherType from 'ui/ManagerFinance/Settings/VoucherTypeSettings/useVoucherType'

type VoucherTypeTextProps = {
	databaseSource: string
	companyUUID: string
	type: number
}

const VoucherTypeText = (props: VoucherTypeTextProps) => {
	const { databaseSource, companyUUID, type: id } = props
	const { voucherType } = useVoucherType({ databaseSource, companyUUID, id })
	return <>{voucherType?.description}</>
}

export default VoucherTypeText
